.button {
  background: white;
  border: 0;
  padding: 8px;
  cursor: pointer;
}

.button:hover {
  background-color: #eee;
}

.icon {
  background-size: contain;
  height: 18px;
  width: 18px;
  margin-top: 2px;
  display: flex;
  opacity: 0.6;
}

.active {
  background-color: #f5f8fd !important;
}

.bold {
  background-image: url("../images/type-bold.svg");
}

.italic {
  background-image: url("../images/type-italic.svg");
}

.underline {
  background-image: url("../images/type-underline.svg");
}

.strikethrough {
  background-image: url("../images/type-strikethrough.svg");
}

.code {
  background-image: url("../images/code.svg");
}

.link {
  background-image: url("../images/link.svg");
}

.subscript {
  background-image: url("../images/type-subscript.svg");
}

.superscript {
  background-image: url("../images/type-superscript.svg");
}

.clear {
  background-image: url("../images/trash.svg");
}
